import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './PageTransition.scss';

interface PageTransitionContextType {
  isTransitioning: boolean;
  navigateWithTransition: (path: string) => void;
}

const PageTransitionContext = createContext<PageTransitionContextType | undefined>(undefined);

export const PageTransitionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [transitionState, setTransitionState] = useState<'idle' | 'entering' | 'exiting'>('idle');
  const navigate = useNavigate();

  const navigateWithTransition = useCallback((path: string) => {
    console.log('navigateWithTransition chiamato:', path);

    // Fase 1: le tende entrano
    setTransitionState('entering');
    console.log('Stato: entering');

    // Fase 2: a metà animazione, naviga
    setTimeout(() => {
      navigate(path);
      window.scrollTo(0, 0);
      // Fase 3: le tende escono
      setTransitionState('exiting');
      console.log('Stato: exiting');
    }, 600);

    // Fase 4: torna allo stato idle
    setTimeout(() => {
      setTransitionState('idle');
      console.log('Stato: idle');
    }, 1200);
  }, [navigate]);

  return (
    <PageTransitionContext.Provider value={{ isTransitioning: transitionState !== 'idle', navigateWithTransition }}>
      {children}
      {/* Overlay tende verticali */}
      <div className={`curtain-transition ${transitionState}`}>
        <div className="curtain-bar"></div>
        <div className="curtain-bar"></div>
        <div className="curtain-bar"></div>
        <div className="curtain-bar"></div>
        <div className="curtain-bar"></div>
      </div>
    </PageTransitionContext.Provider>
  );
};

export const usePageTransition = () => {
  const context = useContext(PageTransitionContext);
  if (!context) {
    // Ritorna valori di default se non dentro il provider
    return { isTransitioning: false, navigateWithTransition: () => {} };
  }
  return context;
};
